<template>
    <div id = 'main-content'>
        <h1 class = 'title'> {{$t('pages.classrooms.allClassroomsList')}}</h1>

        <table id = 'classroomsList'>
            <tr>
                <td><b>{{$t('pages.classrooms.classroomID')}}</b></td>
                <td><b>{{$t('pages.classrooms.classroomName')}}</b></td>
                <td><b>{{$t('pages.classrooms.showSketch')}}</b></td>
                <td><b>{{$t('pages.classrooms.delete')}}</b></td>
            </tr>
            <tr v-for = 'classroom in allClassrooms' :key = 'classroom.id' class = 'classroom'>
                <td>{{classroom.id}}</td>
                <td>{{JSON.parse(classroom.classroomInfo).name}}</td>
                <td><button class = 'sketchButton' @click.prevent = 'showSketch(classroom.id)'> <i class="fa fa-eye  "></i> </button></td>
                <td><button class = 'trashButton' @click.prevent = 'deleteClassroom(classroom.id)'> <span class = "fa fa-trash"></span> </button></td>
            </tr>
        </table>

        <button class = 'addClassroomButton' @click.prevent = 'toggleAddClassroom()'>{{$t('pages.classrooms.addClassroom')}}</button>

    <!-- modal for adding a classroom> -->
    <div class="modal modal-default fade" id="modal-addClassroom">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.editExam.addClassroom')}}</h4>
          </div>
          <div class="modal-body">
            <table v-if = 'wingCount <= 0' style = 'margin: 0 auto; margin-top: 2em; margin-bottom: 2em;'>
              <tr>
                <td>
                  <p class = 'inputInfo'>{{$t('pages.exams.editExam.wingsNumber')}}</p>
                </td>
                <td style = 'width: 60%;'>
                  <input class = 'classroomCount' v-model = 'wings_num' type = 'number'>
                </td>
                <td>
                  <button class = 'confirmButton' @click.prevent = 'buildClassroom(wings_num)'> {{$t('pages.exams.editExam.apply')}}</button>
                </td>
              </tr>
            </table>

            <div v-if ='(wingCount > 0) && !(validSeats)'>
              <p class = 'inputInfo'>{{$t('pages.exams.editExam.insertRowsForEachWing')}}</p>
              <ul class = 'build-classroom-wing-rows'>
                <li v-for = '(wing,index) in classroomStructure.wing' :key = "'wing-'+index">
                  <table>
                    <tr>
                      <td>
                        <p class = 'inputInfo'>{{$t('pages.exams.editExam.wing')}} #{{wing.id + 1}}</p>
                      </td>
                      <td style = 'width: 60%;'>
                        <input class = 'classroomCount' v-model = 'rowCounts[wing.id]' type = 'number'>
                      </td>
                    </tr>
                  </table>
                </li>
                <li style = 'margin-top: 1em;'>
                  <button @click.prevent = 'buildClassroomSetRows()' style = 'width: 30%;' class = 'confirmButton'>{{$t('pages.exams.editExam.apply')}}</button>
                </li>
              </ul>
            </div>

            <div v-if = 'validSeats'>
              <p v-if = '!validClassroom' class = 'inputInfo'>{{$t('pages.exams.editExam.setSeats')}}</p>
                <table class = 'build-classroom-set-seats'>
                  <th v-for='(temp_wing,index) in classroomStructure.wing' :key = "'temp_wing-'+index">
                    {{$t('pages.exams.editExam.wing')}} #{{temp_wing.id + 1}}
                    <ul class = 'build-classroom-rows-set-seats'>
                      <li v-for='(temp_row,ind2) in temp_wing.rows' :key = "'temp_row-'+ind2">
                        <table>
                          <tr>
                            <td style = 'width: 60%;'>
                              {{$t('pages.exams.editExam.row')}} {{Number((temp_row.id).split("_")[1]) + 1}}
                            </td>
                            <td>
                              <input v-model = 'seatStructure[Number((temp_row.id).split("_")[0])][Number((temp_row.id).split("_")[1])]' class = 'seatInput' type = 'number'>
                            </td>
                          </tr>
                        </table>
                      </li>
                    </ul>
                  </th>
                </table>
                <button v-if = '!validClassroom' class = 'confirmSeats confirmButton' @click.prevent = 'buildClassroomSetSeats()'>{{$t('pages.exams.editExam.apply')}}</button>
              </div> 

              <div v-if = 'validClassroom'>
                <p class = 'inputInfo' style = "margin-bottom: 2em;">{{$t('pages.exams.editExam.validClassroom')}}</p>
                <input class = 'inputNameClassroom' v-model = 'classroomName' style = 'margin-bottom: 2em;'>
                <button class = 'confirmSeats confirmButton' @click.prevent = 'submitClassroom()'>{{$t('pages.exercise.finish')}}</button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Rest from './../../services/rest'
import router from './../../router/router.js'
import StopCheating from '@/components/admin/StopCheating.vue'
export default {
  data () {
    return {
      allClassrooms: [],
      chosenClassroom: -1,
      validSeats: false,
      validClassroom: false,
      classroomName: '',
      wingCount: 0,
      wings_num: '',
      rowCounts: [],
      seatStructure: [],
      classroomStructure: {
        info: {},
        wing: {}
      }
    }
  },
  created () {
    this.getClassrooms()
  },
  destroyed () {
  },
  props: [],
  components: {
    'stop-cheating': StopCheating
  },
  methods: {
    getClassrooms () {
      return Rest.request('GET', '/classrooms/getClassrooms').then(data => {
        this.allClassrooms = data
      }).catch(function (err) {
        console.log(err)
      })
    },
    showSketch (id) {
      router.push({name: 'StopCheating', params: {selectedClassroom: id, drawerOnly: true}})
    },
    deleteClassroom (classID) {
      if (confirm(`Ali ste sigurni, da želite izbrisati predavalnico ${classID}?`)) {
        return Rest.request('DELETE', `/classrooms/deleteClassroom/${classID}`).then((data) => {
          this.getClassrooms()
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    toggleAddClassroom () {
      this.resetAllClassroom()
      window.jQuery('#modal-addClassroom').modal('toggle')
    },
    toggleManageClassrooms () {
      this.resetAllClassroom()
      this.getClassrooms()
      window.jQuery('#modal-manageClassrooms').modal('toggle')
    },
    toggleSketch (classroomID) {
      this.classroomSketchID = classroomID
      this.showSketch = !this.showSketch
      window.jQuery('#modal-showSketch').modal('toggle')
    },
    buildClassroom (wings) {
      if (wings > 0) {
        this.wingCount = wings
        this.classroomStructure.info = {}
        this.classroomStructure.wing = []
        for (let i = 0; i < wings; i++) {
          this.classroomStructure.wing[i] = {
            id: i,
            rowCount: 0,
            rows: []
          }
          this.seatStructure[i] = []
        }
      } else {
        alert('Vnesite primerno število kril')
        window.jQuery('#modal-addClassroom').modal('toggle')
      }
    },
    buildClassroomSetRows () {
      for (let i = 0; i < this.classroomStructure.wing.length; i++) {
        if (this.rowCounts[i] > 0) {
          this.classroomStructure.wing[i].rowCount = this.rowCounts[i]
          for (let rowID = 0; rowID < this.classroomStructure.wing[i].rowCount; rowID++) {
            this.classroomStructure.wing[i].rows[rowID] = {
              id: this.classroomStructure.wing[i].id + '_' + rowID,
              seatCount: 0,
              seats: []
            }
          }
        } else {
          alert('Vsa krila morajo imeti vrste. Prosimo, vnesite pravilno zgradbo predavalnice.')
          return
        }
      }
      this.validSeats = true
    },
    buildClassroomSetSeats () {
      for (let wingIndex = 0; wingIndex < this.seatStructure.length; wingIndex++) {
        for (let rowIndex = 0; rowIndex < this.seatStructure[wingIndex].length; rowIndex++) {
          if (this.seatStructure[wingIndex][rowIndex] > 0) {
            this.classroomStructure.wing[wingIndex].rows[rowIndex].seatCount = this.seatStructure[wingIndex][rowIndex]
            for (let seatIndex = 0; seatIndex < this.seatStructure[wingIndex][rowIndex]; seatIndex++) {
              this.classroomStructure.wing[wingIndex].rows[rowIndex].seats[seatIndex] = {
                id: this.classroomStructure.wing[wingIndex].rows[rowIndex].id + '_' + seatIndex
              }
            }
          } else {
            alert('Vse vrste morajo imeti vsaj en sedež')
            return
          }
        }
      }
      this.setupExerciseGroups()
      this.validClassroom = true
    },
    setupExerciseGroups () {
      console.log(this.classroomStructure)
      let exerciseGroups = [ ['A', 'B'], ['C', 'D'] ]
      let exerciseGroupIndex = 0
      let rowMaxCount = 0
      for (let wingIndex = 0; wingIndex < this.classroomStructure.wing.length; wingIndex++) {
        if (this.classroomStructure.wing[wingIndex].rows.length > rowMaxCount) {
          rowMaxCount = this.classroomStructure.wing[wingIndex].rows.length
        }
      }
      for (let rowIndex = 0; rowIndex < rowMaxCount; rowIndex++) {
        for (let wingIndex = 0; wingIndex < this.classroomStructure.wing.length; wingIndex++) {
          if (this.classroomStructure.wing[wingIndex].rows[rowIndex]) {
            for (let seatIndex = 0; seatIndex < this.classroomStructure.wing[wingIndex].rows[rowIndex].seats.length; seatIndex++) {
              this.classroomStructure.wing[wingIndex].rows[rowIndex].seats[seatIndex].exerciseGroup = exerciseGroups[exerciseGroupIndex][seatIndex % 2]
            }
          }
        }
        if (exerciseGroupIndex) {
          exerciseGroupIndex = 0
        } else {
          exerciseGroupIndex = 1
        }
      }
    },
    submitClassroom () {
      if ((this.classroomName.length > 0) && (this.classroomName.length < 20)) {
        this.classroomStructure.info.name = this.classroomName
        let putdata = {
          classroomStructure: this.classroomStructure
        }
        return Rest.request('PUT', '/classrooms/addClassroom', putdata).then((data) => {
          this.resetAllClassroom()
          this.getClassrooms()
          window.jQuery('#modal-addClassroom').modal('toggle')
        }).catch((err) => {
          console.log(err)
        })
      } else {
        alert('Vnesite primerno ime predavalnice!')
      }
    },
    resetAllClassroom () {
      this.validSeats = false
      this.validClassroom = false
      this.classroomName = ''
      this.wingCount = 0
      this.wings_num = 0
      this.rowCounts = []
      this.seatStructure = []
      this.classroomStructure = {
        info: {},
        wing: {}
      }
    }
  }
}
</script>

<style>
    #main-content {
        padding-bottom: 2em;
    }

    .title {
        margin: 0;
        text-align: center;
        font-size: 20px;
    }

    #classroomsList {
        width: 80%;
        margin: 0 auto;
        margin-top: 2em;
        border-collapse:separate; 
        border-spacing: 0 1em;
        margin-bottom: 2em;
    }

    #classroomsList td {
        width: 25%;
    }

    #classroomsList tr {
        margin-bottom: 1em;
    }

    .sketchButton {
        border: 1px solid #3c8dbc;
        border-radius: 40%;
        background: white;
    }

    .sketchButton:hover {
        color: white;
        background: #3c8dbc;
    }

    .trashButton {
        border: 1px solid #3c8dbc;
        border-radius: 40%;
        background: white;
    }

    .trashButton:hover {
        color: white;
        background: #3c8dbc;
    }

    .addClassroomButton {
        display: block;
        margin: 0 auto;
        margin-bottom: 2em;
        color: white;
        font-style: bold;
        padding: 0.5em;
        background: #3c8dbc;
        border-radius: 2em;
        border: 2px solid white;
        outline: none;
    }

    .addClassroomButton:hover {
        color: #3c8dbc;
        background: white;
        border: 2px solid #3c8dbc;
    }

.classroomDropdown {
  margin: auto;
  width: 100%;
  background: transparent;
  margin-right: 0.3em;
  direction: rtl;
  border-left: none;
  border-right: none;
}

.inputInfo {
  font-size: 16px;
}

.classroomCount {
  width: 40%;
  margin-left: 3em;
  margin-bottom: 0.6em;
  border: none;
  outline: none;
}

.confirmButton {
  margin-right: 0.5em;
  margin-bottom: 0.4em;
  background-color: #3c8dbc;
  border: 1px solid #3c8dbc;
  color: white;
  padding: 0.4em;
  border-radius: 30px;
  outline: none;
}

.confirmButton:hover {
  background-color: white;
  color: black;
}

.eyeICON {
  border-radius: 100%;
  border: 1px solid#357ca5;
  background-color: white;
}

.eyeICON:hover {
  background-color: #357ca5;
  color: white;
}

.build-classroom-wing-rows {
  margin-top: 2em;
  list-style-type: none;
}

.build-classroom-set-seats {
  width: 100%;
  margin-top: 3em;
  margin-bottom: 3em;
}

.build-classroom-set-seats th {
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
}

.build-classroom-rows-set-seats {
  list-style-type: none;
  padding: 0;
  font-size: 14px;
  font-weight: normal;
}

.build-classroom-rows-set-seats li {
  margin-top: 2em;
}

.seatInput {
  width: 80%;
  text-align: center;
  border: 0;
  outline: none;
}

.confirmSeats {
  display: block;
  margin: 0 auto;
  margin-bottom: 2em;
  outline: none;
}

.inputNameClassroom {
  padding: 0.5em;
  width: 40%;
  display: block;
  margin: 0 auto;
  border: 1px solid #3c8dbc;
}

#border1 {
    border: 2px solid red;
    border-radius: 5px;
}

    </style>



// WEBPACK FOOTER //
// Classrooms.vue?07122978